import { BRAND } from "../config/brand";

const PATHS = {
  telegram: "M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z",
  instagram: "M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077",
  trustpilot: "M17.227 16.67l2.19 6.742-7.413-5.388 5.223-1.354zM24 9.31h-9.165L12.005.589l-2.84 8.723L0 9.3l7.422 5.397-2.84 8.714 7.422-5.388 4.583-3.326L24 9.311z",
};

const Glyph = ({ name, fill, className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true"><path d={PATHS[name]} fill={fill} /></svg>
);

const Tile = ({ bg, children, small }) => (
  <span
    className={`relative flex shrink-0 items-center justify-center overflow-hidden border border-white/10 shadow-[inset_0_1px_0_rgba(255,255,255,0.18)] ${small ? "h-9 w-9 rounded-xl" : "h-14 w-14 rounded-2xl sm:h-16 sm:w-16"}`}
    style={{ background: bg }}
  >
    {children}
  </span>
);

export const EtoroTile = ({ small }) => (
  <Tile bg="#13C636" small={small}>
    <span className={`font-sans font-extrabold tracking-tight text-white ${small ? "text-[9px]" : "text-[15px] sm:text-[17px]"}`}>eToro</span>
  </Tile>
);

export const TelegramTile = ({ small }) => (
  <Tile bg="#0F2230" small={small}>
    <span className={`absolute rounded-full bg-white ${small ? "h-5 w-5" : "h-7 w-7 sm:h-8 sm:w-8"}`} />
    <Glyph name="telegram" fill="#2AABEE" className={`relative ${small ? "h-6 w-6" : "h-8 w-8 sm:h-9 sm:w-9"}`} />
  </Tile>
);

export const InstagramTile = ({ small }) => (
  <Tile small={small} bg="radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)">
    <Glyph name="instagram" fill="#fff" className={small ? "h-5 w-5" : "h-7 w-7 sm:h-8 sm:w-8"} />
  </Tile>
);

export const TrustpilotTile = ({ small }) => (
  <Tile bg="#0B1F17" small={small}>
    <Glyph name="trustpilot" fill="#00B67A" className={small ? "h-5 w-5" : "h-7 w-7 sm:h-8 sm:w-8"} />
  </Tile>
);

export const WebsiteTile = ({ small }) => (
  <Tile bg="#120D08" small={small}>
    <img src={BRAND.logoSmall} alt="" className={small ? "h-7 w-7" : "h-11 w-11 sm:h-12 sm:w-12"} />
  </Tile>
);

export const ResultsTile = ({ small }) => (
  <Tile small={small} bg="linear-gradient(145deg, #3a2a06 0%, #120c02 100%)">
    <svg viewBox="0 0 24 24" className={small ? "h-5 w-5" : "h-8 w-8 sm:h-9 sm:w-9"} aria-hidden="true">
      <defs>
        <linearGradient id="rt-gold" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#B8860B" />
          <stop offset="1" stopColor="#F3E081" />
        </linearGradient>
      </defs>
      <rect x="3" y="14" width="4" height="7" rx="1.2" fill="url(#rt-gold)" opacity="0.65" />
      <rect x="10" y="10" width="4" height="11" rx="1.2" fill="url(#rt-gold)" opacity="0.85" />
      <rect x="17" y="6" width="4" height="15" rx="1.2" fill="url(#rt-gold)" />
      <path d="M7.5 3.2l.9 1.9 2 .3-1.5 1.4.4 2-1.8-1-1.8 1 .4-2-1.5-1.4 2-.3z" fill="#F3E081" />
    </svg>
  </Tile>
);

export const TILES = {
  etoro: EtoroTile,
  results: ResultsTile,
  telegram: TelegramTile,
  instagram: InstagramTile,
  website: WebsiteTile,
  trustpilot: TrustpilotTile,
};
